import { render } from "./AdminNavbar.vue?vue&type=template&id=5a6ae244&scoped=true"
import script from "./AdminNavbar.vue?vue&type=script&lang=js"
export * from "./AdminNavbar.vue?vue&type=script&lang=js"

import "./AdminNavbar.vue?vue&type=style&index=0&id=5a6ae244&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a6ae244"]])

export default __exports__